import { useCallback } from 'react';
import { toast as sonnerToast } from 'sonner';

export interface Toast {
  id?: string;
  title?: string;
  description?: string;
  variant?: 'default' | 'destructive';
  action?: {
    label: string;
    onClick: () => void;
  };
  duration?: number;
}

export function useToast() {
  const toast = useCallback(
    ({ title, description, variant = 'default', action, duration }: Omit<Toast, 'id'>) => {
      if (variant === 'destructive') {
        sonnerToast.error(title, {
          description,
          action,
          duration,
        });
      } else {
        sonnerToast.success(title, {
          description,
          action,
          duration,
        });
      }
    },
    []
  );

  return { toast };
}
